export const HINT_GENRES = 'hintGenres'
export const HINT_LANGUAGES = 'hintLanguages'
export const CLEAR_HINT = 'clearHint'
